import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';

const loadingAnimation = keyframes`
  0% {
    background-position: 100% 50%;
  }
  50% {
    background-position: 0 50%;
  }
  100% {
    background-position: 100% 50%;
  }
`;

const animatedCss = css`
  ${({
    theme
  }) => css`
    background: linear-gradient(
      45deg,
      ${theme.colors.shades[6]},
      ${theme.colors.shades[5]},
      ${theme.colors.shades[6]}
    );
    background-size: 400% 400%;
    animation: ${loadingAnimation} 1.5s ease infinite;
  `};
`;

const Wrapper = styled.div`
  ${({
    theme
  }) => css`
    display: flex;
    padding: 20px 46px 20px 5px;
    
    @media ${theme.breakpoints.tablet} {
      padding: 15px 36px 16px 0;
    }
    
    @media ${theme.breakpoints.mobile} {
      padding: 10px 31px 10px 0;
    }
  `};
`;

const Image = styled.div`
  width: 40px;
  height: 40px;
  margin: 10px 25px;
  
  ${({
    theme,
    animated
  }) => css`
    background-color: ${theme.colors.shades[6]};
    
    @media ${theme.breakpoints.mobile} {
      margin-left: 20px;
      margin-right: 20px;
    }
    
    ${animated && animatedCss};
  `};
`;

const Content = styled.div`
  flex-grow: 1;
`;

const Line = styled.div`
  ${({
    theme,
    animated, width
  }) => css`
    width: ${width};
    height: 10px;
    margin-bottom: 10px;
    background-color: ${theme.colors.shades[6]};
    
    ${animated && animatedCss};
  `};
`;

/**
 * @tags styled, placeholder, loading
 */
function Placeholder(props) {
  return (
    <Wrapper {...props} data-qa={props.qa}>
      {props.withImage &&
        <Image animated={props.animated} />}

      {props.withContent && (
        <Content>
          {[...Array(props.numberOfLines)].map((n, i) => (
            <Line
              animated={props.animated}
              key={i}
              width={props.randomLineWidth
                ? `${Math.floor(Math.random() * 50) + 50}%`
                : `${props.staticLineWidths[i % props.staticLineWidths.length]}%`}
            />
          ))}
        </Content>
      )}
    </Wrapper>
  );
}

Placeholder.displayName = 'Placeholder';

Placeholder.propTypes = {
  withImage: PropTypes.bool,
  withContent: PropTypes.bool,
  animated: PropTypes.bool,
  randomLineWidth: PropTypes.bool,
  staticLineWidths: PropTypes.arrayOf(PropTypes.number),
  numberOfLines: PropTypes.number,
  qa: PropTypes.string
};

Placeholder.defaultProps = {
  withImage: false,
  withContent: false,
  animated: false,
  randomLineWidth: false,
  staticLineWidths: [50, 85, 70, 55],
  numberOfLines: 4,
  qa: undefined
};

export default Placeholder;
